// Module
var code = `<div class="alert">
    <span>
      <strong>DISCLAIMER:</strong> This form can be used to move customers from one branch to another.
    </span>
  </div>

  <form name="\$ctrl.form">
    <table class="table">
      <thead>
      <tr>
        <th>Select a target branch first.</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Target branch</td>
        <td>
          <select ng-model="\$ctrl.targetBranch"
                  ng-options="\$ctrl.getBranchLabel(branch) for branch in \$ctrl.branches"
                  required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.targetBranch">
        <td>Selection mode</td>
        <td>
          <select ng-model="\$ctrl.cifSelectionMode"
                  ng-options="selectionMode.value as selectionMode.label for selectionMode in \$ctrl.cifSelectionModes"
                  ng-change="\$ctrl.onCifSelectionChanged()"
                  required>
          </select>
        </td>
        <td></td>
      </tr>
      <tr ng-if="\$ctrl.targetBranch && \$ctrl.cifSelectionMode === 'manual-input'">
        <td>Lookup customer</td>
        <td>
          <input ng-model="\$ctrl.searchCifNumber"
                 type="text"
                 placeholder="Cif number"
                 autocomplete="off"
                 ng-keypress="\$event.which === 13 && \$ctrl.searchCustomers()">
          <input ng-model="\$ctrl.searchName"
                 type="text"
                 placeholder="Name"
                 autocomplete="off"
                 ng-keypress="\$event.which === 13 && \$ctrl.searchCustomers()">
        </td>
        <td>
          <button type="button"
                  class="btn btn-primary"
                  ng-disabled="!\$ctrl.searchCifNumber && !\$ctrl.searchName"
                  ng-click="\$ctrl.searchCustomers()">
            Search
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div ng-if="\$ctrl.searchResults.length > 0">
      <table class="table">
        <thead>
        <tr>
          <th>Search results - select the customer to move</th>
        </tr>
        <tr>
          <th>Cif number</th>
          <th>Name</th>
          <th>Status</th>
          <th>Customer Type</th>
          <th>Current branch</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="customer in \$ctrl.searchResults">
          <td>{{customer.customerNumber}}</td>
          <td>{{customer.name}}</td>
          <td>{{customer.customerStatus}}</td>
          <td>{{customer.customerType}}</td>
          <td>{{\$ctrl.getBranchName(customer.branchId)}}</td>
          <td>
            <button type="button"
                    class="btn btn-primary"
                    ng-click="\$ctrl.selectCustomer(customer)">
              Select
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <table class="table">
      <tbody>
      <tr ng-if="\$ctrl.targetBranch && \$ctrl.cifSelectionMode === 'file'">
        <td>Upload cif numbers</td>
        <td>
          <label class="btn btn-default btn-file">
            Load from file...
            <input class="hide"
                   type="file"
                   accept=".txt"
                   file-reader="\$ctrl.file">
          </label>
        </td>
        <td>
          <button type="button"
                  class="btn btn-primary"
                  ng-click="\$ctrl.downloadSample()">
            Download sample
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div ng-if="\$ctrl.customersToBeUpdated.length > 0">
      <table class="table">
        <thead>
        <tr>
          <th>Customers to be moved to another branch</th>
          <th></th>
        </tr>
        <tr>
          <th ng-if="\$ctrl.cifSelectionMode === 'manual-input'">Current branch</th>
          <th>Cif number</th>
          <th ng-if="\$ctrl.cifSelectionMode === 'manual-input'">Name</th>
          <th ng-if="\$ctrl.cifSelectionMode === 'manual-input'">Status</th>
          <th ng-if="\$ctrl.cifSelectionMode === 'manual-input'">Customer Type</th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="customer in \$ctrl.customersToBeUpdated">
          <td ng-if="\$ctrl.cifSelectionMode === 'manual-input'">{{customer.currentBranch}}</td>
          <td>{{customer.customerNumber}}</td>
          <td ng-if="\$ctrl.cifSelectionMode === 'manual-input'">{{customer.name}}</td>
          <td ng-if="\$ctrl.cifSelectionMode === 'manual-input'">{{customer.customerStatus}}</td>
          <td ng-if="\$ctrl.cifSelectionMode === 'manual-input'">{{customer.customerType}}</td>

          <td>
            <button type="button"
                    ng-if="\$ctrl.cifSelectionMode === 'manual-input'"
                    class="btn btn-danger"
                    ng-click="\$ctrl.removeCustomer(\$index)">
              Remove
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div ng-if="\$ctrl.customersToBeUpdated.length > 0" class="flex-end">
      <button
        type="button"
        class=" btn btn-success"
        ng-disabled = "!\$ctrl.targetBranch"
        ng-click="\$ctrl.execute()">
        Execute
      </button>
    </div>
  </form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-cif-branch/update-cif-branch.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;